import { useSyncExternalStore } from 'react'
import { assinarNovaVersao, temNovaVersao } from './nova-versao'

/**
 * "Tem versão nova" — a barra que substituiu o recarregamento automático.
 *
 * Ver `nova-versao.ts` para o porquê. Aqui fica só a aparência da decisão.
 *
 * ## Acima da barra de abas, e não por cima dela
 *
 * As abas são a navegação; cobri-las trocaria um incômodo por outro. A barra
 * senta logo acima, com a mesma margem de segurança de baixo.
 *
 * ## Sem botão de fechar
 *
 * Um "dispensar" faria a pessoa escolher entre atualizar agora e nunca — e
 * "nunca" é o estado em que ela fica com um app diferente do que está no ar,
 * sem saber. Ela some sozinha assim que a aba for escondida (o reload
 * acontece ali), que é o caminho normal num celular.
 */
export function AvisoDeNovaVersao() {
  const pendente = useSyncExternalStore(assinarNovaVersao, temNovaVersao, () => false)
  if (!pendente) return null

  return (
    <div
      role="status"
      className="flutuante fixed inset-x-0 bottom-0 z-40 mx-auto w-full max-w-md px-4 pb-[calc(env(safe-area-inset-bottom)+5.5rem)]"
    >
      <div className="flex items-center gap-3 rounded-full border border-[var(--border-glass)] bg-[var(--surface)] py-2 pr-2 pl-4 shadow-2xl">
        <span className="min-w-0 flex-1 truncate text-xs">Tem uma versão nova do app.</span>
        <button
          type="button"
          onClick={() => {
            window.location.reload()
          }}
          className="alvo shrink-0 rounded-full px-3 text-xs font-medium text-[var(--brand)]"
        >
          Atualizar
        </button>
      </div>
    </div>
  )
}
